export default __webpack_public_path__ + "static/media/defaultcover.787b92d2.png";